module.exports = __webpack_public_path__ + "img/sopasen.9a571b67.jpeg";